import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | paid | failed | timeout
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("failed"); return; }
    let timer;
    const poll = async () => {
      attempts.current += 1;
      if (attempts.current > 10) { setState("timeout"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch (err) {
        // Erro transitório (rede / backend a arrancar): registamos e tentamos de novo.
        console.error("Erro ao verificar o estado do pagamento:", err);
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        {state === "checking" && (
          <>
            <Loader2 data-testid="payment-checking" className="w-12 h-12 text-slate-400 animate-spin mx-auto mb-4" />
            <h1 className="font-heading font-black tracking-tighter text-2xl text-slate-900">A confirmar pagamento...</h1>
            <p className="text-sm text-slate-500 mt-2">Aguarda uns segundos, não feches esta página.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 data-testid="payment-success" className="w-12 h-12 text-emerald-500 mx-auto mb-4" />
            <h1 className="font-heading font-black tracking-tighter text-2xl text-slate-900">Destaque ativado!</h1>
            <p className="text-sm text-slate-500 mt-2">A tua vaga já está com prioridade na listagem.</p>
            <Button data-testid="payment-back-btn" className="rounded-full bg-slate-900 hover:bg-slate-800 mt-8" onClick={() => navigate("/empresa")}>Voltar ao painel</Button>
          </>
        )}
        {(state === "failed" || state === "timeout") && (
          <>
            <XCircle data-testid="payment-failed" className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="font-heading font-black tracking-tighter text-2xl text-slate-900">
              {state === "timeout" ? "Confirmação demorada" : "Pagamento não confirmado"}
            </h1>
            <p className="text-sm text-slate-500 mt-2">
              {state === "timeout" ? "Verifica o estado no teu painel dentro de momentos." : "O pagamento não foi concluído. Tenta novamente."}
            </p>
            <Button className="rounded-full bg-slate-900 hover:bg-slate-800 mt-8" onClick={() => navigate("/empresa")}>Voltar ao painel</Button>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <XCircle data-testid="payment-cancelled" className="w-12 h-12 text-slate-400 mx-auto mb-4" />
        <h1 className="font-heading font-black tracking-tighter text-2xl text-slate-900">Pagamento cancelado</h1>
        <p className="text-sm text-slate-500 mt-2">Não foi cobrado nada. Podes tentar novamente quando quiseres.</p>
        <Button className="rounded-full bg-slate-900 hover:bg-slate-800 mt-8" onClick={() => navigate("/empresa")}>Voltar ao painel</Button>
      </div>
    </div>
  );
}
